import { useEffect } from "react"
import type { ReactNode } from "react"

import { usePublicPartnerRetrieve } from "@boundless/bl-api-client/public/services"
import { useStore } from "zustand"

import { PendingComponent } from "@/components/error/PendingComponent"
import { usePortalContainer } from "@/components/ui/portal-container"
import { store } from "@/lib/store"
import { getThemeTarget } from "@/lib/utils"

type EmbedThemeWrapperProps = {
  children: ReactNode
  partnerId: string
}

export function EmbedThemeWrapper({
  children,
  partnerId,
}: EmbedThemeWrapperProps) {
  const portalContainer = usePortalContainer()
  const primaryColor = useStore(store, (state) => state.primaryColor)
  const headerGradientColor = useStore(
    store,
    (state) => state.headerGradientColor,
  )
  const accentColor = useStore(store, (state) => state.accentColor)

  const { data: theme, isLoading } = usePublicPartnerRetrieve(partnerId)

  useEffect(() => {
    if (theme) {
      store.setState({
        partnerLogo: theme.logo,
        primaryColor: theme.primaryColor,
        headerGradientColor: theme.headerGradientColor,
        accentColor: theme.accentColor,
        perksEnabled: theme.perksEnabled ?? true,
        embedHideHeader: theme.embedHideHeader ?? false,
      })
    }
  }, [theme])

  useEffect(() => {
    const target = getThemeTarget(portalContainer)
    const gradientColor = headerGradientColor ?? primaryColor ?? ""

    target.style.setProperty("--primary", primaryColor ?? "")
    target.style.setProperty("--header-gradient-color", gradientColor)
    target.style.setProperty("--brand-accent", accentColor ?? "")
  }, [theme, primaryColor, headerGradientColor, accentColor, portalContainer])

  return <>{isLoading ? <PendingComponent /> : children}</>
}
